import React from "react";
import { useParams, useLocation } from "react-router-dom";
import SiteRegisterList from "./SiteRegisterList";

function SiteRegisterListPage() {
  const { userId } = useParams();
  // If userId is not present, try to get from localStorage
  let effectiveUserId = userId;
  if (!effectiveUserId) {
    const user = JSON.parse(localStorage.getItem("user"));
    effectiveUserId = user && user.id;
  }
  return <SiteRegisterList userId={effectiveUserId} />;
}

export default SiteRegisterListPage;
